import { Template } from "devextreme-react";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import moment from "moment";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  Scrolling,
  SearchPanel,
} from "devextreme-react/data-grid";
import { DateFormat } from "../../helpers/fixcodes";
import Modal from "react-modal";
import { axiosGet, axiosPost } from "../../apis/useAxios";
import { DataGridSkeletonPageSimpleWithTitle } from "../skeleton/GridSkeleton";

export default function ActivityDutyLocationTransferComponent() {
  const [state, setState] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [
    activityDutyLocationTransferDataGridSource,
    setActivityDutyLocationTransferDataGridSource,
  ] = useState(false);
  const refDataGrid = useRef([]);

  useLayoutEffect(() => {
    document.querySelector(
      "#lblPageTitle"
    ).innerHTML = `Activity Duty Location Transfer`;
  });

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnLoad = async () => {
    try {
      setTimeout(async () => {
        setIsLoading(true);
        await getActivityLocationDutyTransfer();
        setIsLoading(false);
      }, 0);
    } catch (error) {
      console.log(error);
    }
  };

  const getActivityLocationDutyTransfer = async () => {
    try {
      const response = await axiosGet(
        `/CrewTypeConfiguration/ActivityDutyLocationTransfer`,
        {
          AirlineCode: sessionStorage.getItem("session_airlineCode"),
          AirportCode: "",
        }
      );
      setActivityDutyLocationTransferDataGridSource(response?.payload ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const renderGridCell = (data) => {};

  return (
    <>
      {/* <div className="filter-box">
        <div className="card p-2 m-0">
          <div className="row"></div>
        </div>
      </div> */}
      <div className="card">
        <div className="card-body">
          {isLoading && <DataGridSkeletonPageSimpleWithTitle />}
          {!isLoading && (
            <>
              <DataGrid
                ref={refDataGrid}
                dataSource={activityDutyLocationTransferDataGridSource}
                columnAutoWidth={true}
                showColumnLines={true}
                showRowLines={true}
                showBorders={true}
                rowAlternationEnabled={false}
                allowColumnResizing={true}
                onCellPrepared={(e) => {}}
                onToolbarPreparing={(e) => {
                  e.toolbarOptions.items.unshift({
                    location: "after",
                    widget: "dxButton",
                    options: {
                      icon: "refresh",
                      onClick: async (e) => {
                        try {
                          refDataGrid.current.instance.beginCustomLoading();
                          e.component.option("icon", "fas fa-spinner fa-spin");
                          await new Promise((resolve) =>
                            setTimeout(resolve, 500)
                          );
                          await getActivityLocationDutyTransfer();
                          refDataGrid.current.instance.endCustomLoading();
                          e.component.option("icon", "refresh");
                        } catch (error) {
                          console.log(error);
                        }
                      },
                    },
                  });
                }}
              >
                {/* <Column
                  dataField="id"
                  caption=""
                  allowFiltering={false}
                  allowSorting={false}
                  allowSearch={false}
                  width={"auto"}
                  //alignment={"left"}
                  cellRender={renderGridCell}
                /> */}
                <Column
                  dataField="airlineCode"
                  caption="Airline"
                  allowFiltering={false}
                  allowSorting={false}
                  allowSearch={true}
                  width={100}
                  alignment={"center"}
                />
                <Column
                  dataField="airportCode"
                  caption="Airport"
                  allowSearch={true}
                  allowFiltering={true}
                  allowSorting={true}
                />
                <Column
                  dataField="locationCode"
                  caption="Location Code"
                  allowSearch={true}
                  allowFiltering={true}
                  allowSorting={true}
                />
                <Column
                  dataField="crewTypeCategory"
                  caption="Crew Type Stay For"
                  allowSearch={true}
                  allowFiltering={true}
                  allowSorting={true}
                />
                <Column
                  dataField="transporterName"
                  caption="Transport"
                  allowSearch={true}
                  allowFiltering={true}
                  allowSorting={true}
                />
                <Column
                  dataField="transporterEmail"
                  caption="Email"
                  allowSearch={true}
                  allowFiltering={true}
                  allowSorting={true}
                />
                <Column
                  dataField="transporterPhoneNo"
                  caption="Phone"
                  allowSearch={true}
                  allowFiltering={true}
                  allowSorting={true}
                />
                <Column
                  dataField="singleTripVehicleType"
                  caption="Single Trip Vehicle Type"
                  allowSearch={true}
                  allowFiltering={true}
                  allowSorting={true}
                />
                <Column
                  dataField="pilotVehicleType"
                  caption="Pilot Vehicle Type"
                  allowSearch={true}
                  allowFiltering={true}
                  allowSorting={true}
                />
                <Column
                  dataField="flightAttendantVehicleType"
                  caption="Flight Attendant Vehicle Type"
                  allowSearch={true}
                  allowFiltering={true}
                  allowSorting={true}
                />
                <Column
                  dataField="wefDate"
                  caption="Wef Date"
                  allowSearch={true}
                  allowFiltering={true}
                  allowSorting={true}
                  dataType="datetime"
                  format={DateFormat.DateNorthFormat}
                />
                <Column
                  dataField="endDate"
                  caption="End Date"
                  allowSearch={true}
                  allowFiltering={true}
                  allowSorting={true}
                  dataType="datetime"
                  format={DateFormat.DateNorthFormat}
                />
                <Column
                  dataField="effectedDate"
                  caption="Effected Date"
                  allowSearch={true}
                  allowFiltering={true}
                  allowSorting={true}
                  dataType="datetime"
                  format={DateFormat.DateNorthFormat}
                />
                <HeaderFilter visible={true} />
                <Paging defaultPageSize={20} />
                <Pager
                  showPageSizeSelector={true}
                  allowedPageSizes={[10, 20, 50]}
                  showInfo={true}
                  visible={true}
                />
                <SearchPanel
                  visible={true}
                  highlightCaseSensitive={true}
                  width={240}
                  placeholder="Search..."
                />
                <Export
                  enabled={true}
                  allowExportSelectedData={false}
                  fileName="ActivityDutyLocationTransfer"
                />
              </DataGrid>
            </>
          )}
        </div>
      </div>
    </>
  );
}
